import PropTypes from 'prop-types';

export default function Fab({ children }) {
  return (
    <div className="fixed bottom-16 right-[6%] z-30 mx-auto grid place-items-center rounded-full p-1 max-[639px]:h-14 max-[639px]:w-14">
      {children}
    </div>
  );
}

Fab.propTypes = {
  children: PropTypes.node.isRequired,
};
